export function initLatestReviews() {
    const expendables = document.querySelectorAll('[data-expendable]')

    expendables.forEach((expendable) => {
        const expandButton = expendable.querySelector('[data-expendable-button]')
        const text = expendable.querySelector('[data-expendable-text]')

        const expendableHeight = expendable.offsetHeight
        text.removeAttribute('data-expendable-text')
        const unclampedTextHeight = text.offsetHeight
        text.setAttribute('data-expendable-text', true)

        setTimeout(() => {
            if (unclampedTextHeight < expendableHeight) return expandButton.remove()
            expandButton.addEventListener('click', () => {
                text.removeAttribute('data-expendable-text')
                expandButton.remove()
            }, { once: true })
        })
    })
}